import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "survey-display-item" }

import {
    ConversationItem,
    ConversationSpec,
    CurrentAnswer,
    Options,
    SurveyDisplayValues,
    SurveyParams,
    TYPE_REVIEW_LINK_BUTTON,
    OptionLabels,
} from '@/entities/conversation'
import ConversationItemSay from './ConversationItemSay.vue'
import ConversationItemSayAI from './ConversationItemSayAI.vue'
import ConversationItemReviewLink from './ConversationItemReviewLink.vue'
import ConversationItemReceiveOption from './ConversationItemReceiveOption.vue'
import ConversationItemCalendly from './ConversationItemCalendly.vue'
import ConversationItemReceiveText from './ConversationItemReceiveText.vue'
import { getCDNUrl } from '@/utils/cdn'

interface Props {
    surveyNode: ConversationItem
    surveyDisplayValues?: SurveyDisplayValues
    surveyParams: SurveyParams
    surveyQuestionsAndAnswers: CurrentAnswer[]
    isActive: boolean
    isFollowedByInput?: boolean
    surveySpec: ConversationSpec
    csatLabels: Options
    isPreview: boolean
    optionLabels: OptionLabels | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConversationDisplayItems',
  props: {
    surveyNode: {},
    surveyDisplayValues: {},
    surveyParams: {},
    surveyQuestionsAndAnswers: {},
    isActive: { type: Boolean },
    isFollowedByInput: { type: Boolean },
    surveySpec: {},
    csatLabels: {},
    isPreview: { type: Boolean },
    optionLabels: {}
  },
  emits: ['nextNode', 'updateScore', 'saveAiQuestion'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const avatarSrc = getCDNUrl(props.surveyParams.avatar)

const handleNextNode = (newValue = null, answerString = null) => {
    emit('nextNode', newValue, answerString)
}

const handleUpdateScore = (data) => {
    emit('updateScore', data)
}

const saveAiQuestion = (
    aiQuestion = null,
    aiAnswer = null,
    aiQuestionIndex = 1,
    isFocusAreaQuestion = false
) => {
    emit(
        'saveAiQuestion',
        aiQuestion,
        aiAnswer,
        aiQuestionIndex,
        isFocusAreaQuestion
    )
}

if (
    props.surveyNode.type === 'Say' &&
    props.surveyNode.cardType === TYPE_REVIEW_LINK_BUTTON
) {
    handleNextNode()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (
                _ctx.surveyNode.type === 'Say' &&
                _ctx.surveyNode.cardType !== _unref(TYPE_REVIEW_LINK_BUTTON) &&
                _ctx.surveyNode.aiConversationalMode !== true
            )
      ? (_openBlock(), _createBlock(ConversationItemSay, {
          key: 0,
          message: _ctx.surveyNode.value,
          "survey-display-values": _ctx.surveyDisplayValues,
          "survey-params": _ctx.surveyParams,
          "avatar-src": _unref(avatarSrc),
          "is-active": _ctx.isActive,
          "is-followed-by-input": _ctx.isFollowedByInput,
          "csat-labels": props.csatLabels,
          onCallNext: handleNextNode,
          onUpdateScore: handleUpdateScore
        }, null, 8, ["message", "survey-display-values", "survey-params", "avatar-src", "is-active", "is-followed-by-input", "csat-labels"]))
      : _createCommentVNode("", true),
    (
                _ctx.surveyNode.type === 'Say' &&
                _ctx.surveyNode.cardType !== _unref(TYPE_REVIEW_LINK_BUTTON) &&
                _ctx.surveyNode.aiConversationalMode === true
            )
      ? (_openBlock(), _createBlock(ConversationItemSayAI, {
          key: 1,
          item: _ctx.surveyNode,
          "survey-display-values": _ctx.surveyDisplayValues,
          "survey-params": _ctx.surveyParams,
          "survey-questions-and-answers": _ctx.surveyQuestionsAndAnswers,
          "avatar-src": _unref(avatarSrc),
          "is-active": _ctx.isActive,
          "is-preview": _ctx.isPreview,
          onCallNext: handleNextNode,
          onSaveAiQuestion: saveAiQuestion
        }, null, 8, ["item", "survey-display-values", "survey-params", "survey-questions-and-answers", "avatar-src", "is-active", "is-preview"]))
      : _createCommentVNode("", true),
    (
                _ctx.surveyNode.type === 'ReceiveText' &&
                _ctx.surveyNode.param === _unref(TYPE_REVIEW_LINK_BUTTON)
            )
      ? (_openBlock(), _createBlock(ConversationItemReviewLink, {
          key: 2,
          item: _ctx.surveyNode,
          "survey-display-values": _ctx.surveyDisplayValues,
          slug: props.surveyParams.slug,
          onCallNext: handleNextNode
        }, null, 8, ["item", "survey-display-values", "slug"]))
      : _createCommentVNode("", true),
    (_ctx.surveyNode.type === 'ReceiveOption' && !_ctx.surveyNode.link)
      ? (_openBlock(), _createBlock(ConversationItemReceiveOption, {
          key: 3,
          item: _ctx.surveyNode,
          "survey-display-values": _ctx.surveyDisplayValues,
          "survey-params": _ctx.surveyParams,
          "option-labels": _ctx.optionLabels,
          onCallNext: handleNextNode
        }, null, 8, ["item", "survey-display-values", "survey-params", "option-labels"]))
      : _createCommentVNode("", true),
    (_ctx.surveyNode.type === 'ReceiveOption' && _ctx.surveyNode.link)
      ? (_openBlock(), _createBlock(ConversationItemCalendly, {
          key: 4,
          item: _ctx.surveyNode,
          "survey-spec": _ctx.surveySpec,
          "survey-display-values": _ctx.surveyDisplayValues,
          onCallNext: handleNextNode
        }, null, 8, ["item", "survey-spec", "survey-display-values"]))
      : _createCommentVNode("", true),
    (
                _ctx.surveyNode.type === 'ReceiveText' &&
                _ctx.surveyNode.param !== _unref(TYPE_REVIEW_LINK_BUTTON)
            )
      ? (_openBlock(), _createBlock(ConversationItemReceiveText, {
          key: 5,
          item: _ctx.surveyNode,
          "survey-display-values": _ctx.surveyDisplayValues,
          onCallNext: handleNextNode
        }, null, 8, ["item", "survey-display-values"]))
      : _createCommentVNode("", true)
  ]))
}
}

})